$(function() {
    $(
        ".module-banner-narrow-image .module-banner-body .row .col-12.col-md-7.col-lg-12.col-xl-4"
    )
        .removeClass("col-12 col-md-7 col-lg-12 col-xl-4")
        .addClass("col-12 col-lg-6");
});
